import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { findIndex, isEmpty } from 'lodash';

import { WorkShiftService } from '../work-shift.service';
import { AuthService } from '../../auth/auth.service';
import { WORK_SHIFT_PATHS } from '../work-shift';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';

export interface Sector {
  sector_id: number;
  sector_number_str: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-work-shift',
  templateUrl: './work-shift.component.html',
  styleUrls: ['./work-shift.component.scss'],
  standalone: false,
})
export class WorkShiftComponent implements OnInit {
  public moment = require('moment');
  public WORK_SHIFT_PATHS = WORK_SHIFT_PATHS;
  public initDataLoading: boolean;
  public sectorsList: Sector[] | null;
  public sectorSelected: Sector;
  public sectorId: string | number | null;
  public usersBreadcrumbs = [{ text: 'Смена', url: null }];
  public subChildren: object | null;
  public currentDate = new Date();

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private workShiftService: WorkShiftService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  get isGRS() {
    return this.authService.isGRSUser();
  }

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.usersBreadcrumbs);
    let childRoute = this.route.children;

    this.workShiftService.setSectorData({ sector_id: null });
    this.workShiftService.subscribeSectorData().subscribe((data) => {
      this.sectorId = +data.sector_id;
    });

    if (childRoute && childRoute.length) {
      childRoute[0].paramMap.subscribe((paramMap) => {
        this.sectorId = +paramMap.get('sector_id');
        this.getInitData();
      });
    } else {
      this.getInitData();
    }

    this.moment.updateLocale('ru', {
      months: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
    });
  }

  private getInitData() {
    if (this.sectorsList) {
      return;
    }
    let params = { sector_id: null };

    if ([1, 2].indexOf(this.authService.getAuthKey('current_group')['id']) > -1 && this.sectorId) {
      params.sector_id = this.sectorId;
    } else {
      delete params.sector_id;
    }

    this.initDataLoading = true;
    this.workShiftService.getInitDataUnion(this.authService.getAuthKey('u_id'), params).subscribe(
      (response) => {
        // this.workShift.data.time = response[0]['data'];
        this.sectorsList = response[0]['data'];

        if (this.sectorId) {
          let brigadeIndex = findIndex(this.sectorsList, (sector) => sector.sector_id === +this.sectorId);

          if (brigadeIndex > -1) {
            this.onChangeSectorSelected(this.sectorsList[brigadeIndex]);
          }
        } else {
          this.sectorId = this.sectorsList[0].sector_id;
          this.onChangeSectorSelected(this.sectorsList[0]);
        }
        this.initDataLoading = false;
      },
      (error) => {
        console.log(error);
        this.initDataLoading = false;
      }
    );
  }

  public onChangeSectorSelected(selected) {
    this.sectorSelected = selected;
    this.workShiftService.setSectorData(selected);
    this.router.navigate(this.makeLink(selected, true), {
      replaceUrl: true,
    });
  }

  public onSelectSector(selected) {
    this.sectorId = selected.sector_id;
    this.sectorSelected = selected;
    this.workShiftService.setSectorData(selected);
  }

  public makeLink(sector, isPathMake) {
    let path;

    if (isPathMake) {
      path = [WORK_SHIFT_PATHS.work_shift, WORK_SHIFT_PATHS.work_shift_s, sector.sector_id];
    } else {
      path = [WORK_SHIFT_PATHS.work_shift_s, sector.sector_id];
    }

    // Простая логика для определения текущего маршрута
    try {
      let children = (this.route.children && this.route.children[0]) || null;
      let subChildren = (children && children.children && children.children[0]) || null;

      if (subChildren && subChildren.snapshot && subChildren.snapshot.routeConfig) {
        let currentPath = subChildren.snapshot.routeConfig.path;
        if (currentPath) {
          path.push(currentPath);
        }
      } else {
        // Дефолтный маршрут
        path.push(WORK_SHIFT_PATHS.work_shift_tickets);
      }
    } catch (error) {
      // Если произошла ошибка с доступом к snapshot, используем дефолтный маршрут
      console.warn('Error accessing route snapshot, using default path:', error);
      path.push(WORK_SHIFT_PATHS.work_shift_tickets);
    }

    return path;
  }
}
